import * as yup from "yup";

export const PasswordExpirationSchema = yup.object().shape({
  PasswordExpiration: yup
    .number()
    .typeError("Please enter a valid number of days between (1-365)")
    .required("Please enter a valid number of days between (1-365)")
    .min(1, "Please enter a valid number of days between (1-365)")
    .max(365, "Please enter a valid number of days between (1-365)"),
});
